import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinchiklipune() {



const cardData = {
  keyword: " Cab Service in Chikhali Pune ",

"headingDescription": "SRS Cab Service provides Cab Service in Chikhali Pune, offering smooth, affordable, and dependable travel solutions for residents, workers, and families. Whether you need a ride for daily commuting, industrial visits, airport transfers, or outstation travel, our well-maintained vehicles and experienced drivers ensure a safe and comfortable journey. With easy booking, transparent pricing, and 24/7 customer support, SRS Cab Service makes travel in Chikhali convenient and worry-free.",
"topPlaces": [
  {
    "title": "Chikhali Industrial Area",
    "description": "Chikhali Industrial Area is a major employment hub attracting daily commuters and business visitors. Travelers using Cab Service in Chikhali Pune from SRS Cab Service frequently travel here for work and meetings."
  },
  {
    "title": "Spine Road",
    "description": "Spine Road is a key connectivity route near Chikhali, linking various parts of PCMC. Visitors using SRS Cab Service often commute through this road for quick and efficient travel."
  },
  {
    "title": "Akkalkot Swami Samarth Mandir",
    "description": "This spiritual destination near Chikhali is visited by devotees for peace and blessings. Travelers using SRS Cab Service often include it in their visits."
  },
  {
    "title": "Pimpri Chinchwad Science Park",
    "description": "A popular educational and recreational spot for families and children. Visitors using SRS Cab Service often plan outings to this interactive park."
  },
  {
    "title": "Appu Ghar Amusement Park",
    "description": "Appu Ghar is a well-known amusement park offering rides and entertainment. Travelers using SRS Cab Service often visit for family fun and relaxation."
  },
  {
    "title": "PCMC Stadium",
    "description": "PCMC Stadium hosts sports events and activities. Visitors using SRS Cab Service often travel here for matches and fitness programs."
  },
  {
    "title": "Durga Tekdi",
    "description": "Durga Tekdi is a scenic hill offering fresh air and peaceful surroundings. Travelers using SRS Cab Service often visit for walks and relaxation."
  },
  {
    "title": "Kasarwadi Market",
    "description": "Kasarwadi Market is a busy shopping hub with local shops and eateries. Visitors using SRS Cab Service often explore this area for shopping and food."
  },
  {
    "title": "Chinchwad Ganpati Temple",
    "description": "Chinchwad Ganpati Temple is a famous religious site attracting devotees. Travelers using SRS Cab Service often visit to seek blessings."
  },
  {
    "title": "Rajiv Gandhi Infotech Park",
    "description": "Rajiv Gandhi Infotech Park is a major IT hub located near Chikhali. Business travelers using SRS Cab Service frequently commute here for professional work."
  }
],



services: [
{
name: "Chikhali Cab Service",
description: "Chikhali cab service offers reliable transportation for local and outstation travel. Customers can book cabs for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service in Chikhali Pune",
description: "Taxi service in Chikhali Pune provides convenient travel for local and intercity routes. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Chikhali Taxi Service",
description: "Chikhali taxi service offers dependable transportation for daily and outstation travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Chikhali Pune",
description: "Cab booking Chikhali Pune provides quick and easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Taxi Booking Chikhali Pune",
description: "Taxi booking Chikhali Pune offers convenient booking services for local and airport travel. Customers can reserve taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi booking services."
},
{
name: "Cab Near Chikhali Pune",
description: "Cab near Chikhali Pune helps customers find nearby taxis instantly. Users can book cabs for local and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with nearby cab services."
},
{
name: "Taxi Near Chikhali Pune",
description: "Taxi near Chikhali Pune offers quick access to local and airport travel options. Customers can book taxis instantly for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Best Cab Service in Chikhali Pune",
description: "Best cab service in Chikhali Pune provides top-rated transportation for customers. Users can enjoy reliable and comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Cheap Cab Service Chikhali",
description: "Cheap cab service Chikhali offers affordable travel options for customers. Users can book budget-friendly rides for local and outstation trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Affordable Cab Service Chikhali",
description: "Affordable cab service Chikhali provides cost-effective travel solutions for customers. Users can book economical rides for daily and intercity travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Chikhali Cab Hire",
description: "Chikhali cab hire offers flexible rental options for local and outstation travel. Customers can book cabs for hourly and daily use. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab hire services."
},
{
name: "Chikhali Taxi Hire",
description: "Chikhali taxi hire provides convenient rental services for customers. Users can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
},
{
name: "Chikhali Cab for Airport",
description: "Chikhali cab for airport offers reliable transfer for passengers. Customers can book cabs for timely airport drop and pickup. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Chikhali Airport Cab Service",
description: "Chikhali airport cab service provides convenient airport transfer solutions. Customers can book cabs for timely travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Chikhali Cab for Outstation",
description: "Chikhali cab for outstation offers reliable travel for long-distance trips. Customers can book cabs for tours and business journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Cab Service Chikhali Pune",
description: "Cab service Chikhali Pune provides dependable transportation for city and intercity travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Service Chikhali Pune",
description: "Taxi service Chikhali Pune offers reliable transportation for local and airport travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Booking Chikhali",
description: "Cab booking Chikhali provides easy reservation options for customers. Users can book rides anytime for travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Innova Cab Chikhali",
description: "Innova cab Chikhali offers spacious SUV travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Ideal for long-distance travel. Travel easily with Innova cab services."
},
{
name: "Innova Crysta Cab Chikhali",
description: "Innova Crysta cab Chikhali provides premium SUV travel for comfort and luxury. Customers can enjoy spacious seating and smooth rides. Professional drivers ensure safe journeys. Ideal for corporate and family travel. Transparent pricing ensures value. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Cab Chikhali",
description: "Ertiga cab Chikhali offers comfortable 7 seater travel for families and groups. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
},
{
name: "Dzire Cab Chikhali",
description: "Dzire cab Chikhali provides affordable sedan travel for local and outstation trips. Customers can book vehicles for comfortable journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "Sedan Cab Chikhali",
description: "Sedan cab Chikhali offers budget-friendly travel for daily and outstation journeys. Customers can book vehicles for flexible trips. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan services."
},
{
name: "Luxury Cab Chikhali",
description: "Luxury cab Chikhali provides premium travel experience for corporate and special trips. Customers can enjoy high-end vehicles and comfort. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with luxury cab services."
},
{
name: "Tempo Traveller Chikhali",
description: "Tempo traveller Chikhali offers group travel solutions for family and corporate trips. Customers can book vehicles for outstation journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Urbania on Rent Chikhali",
description: "Urbania on rent Chikhali provides luxury group travel for large families and corporate trips. Customers can book premium vehicles for long-distance journeys. Professional drivers ensure safe travel. Spacious seating enhances comfort. Flexible booking options are available. Travel easily with Urbania services."
},
{
name: "Best Cab Service in Chikhali Pune for Airport Drop",
description: "Best cab service in Chikhali Pune for airport drop offers reliable transfer for passengers. Customers can book cabs for timely airport travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with airport cab services."
},
{
name: "Affordable Cab Service Chikhali for Outstation",
description: "Affordable cab service Chikhali for outstation provides cost-effective travel solutions. Customers can book cabs for long-distance journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Chikhali Cab Service for Family Trip",
description: "Chikhali cab service for family trip offers comfortable travel for vacations and outings. Customers can book spacious vehicles for group travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with family trip cab services."
},
{
name: "Reliable Taxi Service Chikhali Pune",
description: "Reliable taxi service Chikhali Pune provides dependable transportation for customers. Users can book taxis for daily and outstation travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
}
],

tableData: [
["Chikhali Cab Service","Taxi Service in Chikhali Pune"],
["Chikhali Taxi Service","Cab Booking Chikhali Pune"],
["Taxi Booking Chikhali Pune","Cab Near Chikhali Pune"],
["Taxi Near Chikhali Pune","Best Cab Service in Chikhali Pune"],
["Cheap Cab Service Chikhali","Affordable Cab Service Chikhali"],
["Chikhali Cab Hire","Chikhali Taxi Hire"],
["Chikhali Cab for Airport","Chikhali Airport Cab Service"],
["Chikhali Cab for Outstation","Cab Service Chikhali Pune"],
["Taxi Service Chikhali Pune","Cab Booking Chikhali"],
["Innova Cab Chikhali","Innova Crysta Cab Chikhali"],
["Ertiga Cab Chikhali","Dzire Cab Chikhali"],
["Sedan Cab Chikhali","Luxury Cab Chikhali"],
["Tempo Traveller Chikhali","Urbania on Rent Chikhali"]
],



whychoose: [
  {
    WhyChooseheading: "Reliable Cab Service in Chikhali Pune",
    WhyChoosedescription: "SRS Cab Service provides dependable cab service in Chikhali Pune for local travel, airport transfers, and outstation trips with professional drivers."
  },
  {
    WhyChooseheading: "Affordable & Transparent Pricing",
    WhyChoosedescription: "We offer budget-friendly cab service in Chikhali with clear pricing. Customers get complete fare details including tolls and driver charges without hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our taxi service in Chikhali Pune operates 24/7, making it convenient for daily travel, office commutes, emergency rides, and late-night bookings."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and luxury vehicles based on your travel needs."
  },
  {
    WhyChooseheading: "Comfortable & Well-Maintained Vehicles",
    WhyChoosedescription: "All vehicles are clean, air-conditioned, and regularly serviced to ensure a comfortable and safe ride experience."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Chikhali Area",
    WhyChoosedescription: "We provide quick pickup from homes, societies, industrial areas, and nearby locations like Bhosari, Moshi, and Chinchwad."
  },
  {
    WhyChooseheading: "Ideal for Airport & Outstation Travel",
    WhyChoosedescription: "Our Chikhali cab service is perfect for Pune Airport drop, Mumbai travel, family trips, and long-distance outstation journeys."
  },
  {
    WhyChooseheading: "Trusted Cab Service in Chikhali Pune",
    WhyChoosedescription: "SRS Cab Service is trusted by customers for punctual service, professional drivers, and reliable travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide cab service in Chikhali Pune?", answer: "Yes, SRS Cab Service offers reliable cab services in Chikhali Pune for local and outstation travel." },
  { question: "Is taxi service available 24 hours in Chikhali?", answer: "Yes, our taxi service operates 24/7 for all travel needs." },
  { question: "Do you provide airport cab service from Chikhali?", answer: "Yes, we provide Pune Airport pickup and drop services from Chikhali." },
  { question: "Which areas do you cover near Chikhali?", answer: "We cover Moshi, Bhosari, Chinchwad, Talawade, and nearby PCMC areas." },
  { question: "Which vehicles are available?", answer: "We offer sedan cars, SUVs, Innova Crysta, Tempo Travellers, and luxury vehicles." },
  { question: "Can I book cab online in Chikhali?", answer: "Yes, you can easily book cab service online or via phone." },
  { question: "Do you provide outstation cab from Chikhali?", answer: "Yes, we provide outstation cab services from Chikhali to Mumbai, Nashik, Shirdi, Goa, and more." },
  { question: "Are drivers professional?", answer: "Yes, all drivers are trained, experienced, and verified." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Patil",
    feedback:
      "Booked cab from Chikhali to airport. Very smooth ride and quick pickup.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Kulkarni",
    feedback:
      "Best cab service in Chikhali Pune. Clean car, affordable pricing, and professional driver.",
    rating: 5
  }
];




















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Chikhali Pune Cab Service",
  "description": "Reliable cab service in Chikhali, Pune with SRS Cab. Book taxis for local travel, airport transfers, and outstation trips. 24/7 service with Innova, Ertiga, sedan, tempo traveller, and mini bus options.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Chikhali",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411062",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.6810",
    "longitude": "73.8180"
  },
  "url": "https://www.srscabservice.com/chikhali-pune-cab-service",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1475"
  },
  "areaServed": {
    "@type": "City",
    "name": "Chikhali, Pune"
  }
};







  return (
    <div>
      

<Helmet>
  <title>Cab Service in Chikhali Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable cab service in Chikhali, Pune with SRS Cab. Local rides, airport transfers, and outstation trips available 24/7. Innova, Ertiga, sedan, tempo traveller, and mini bus options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/92.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinchiklipune;